(() => {
	/**
	 * Price Toggle.
	 *
	 * Writes the chosen period onto the nearest Section (falling back to the
	 * <body>), and every Pricing Card underneath it swaps which of its two price
	 * figures is displayed -- see block-pricing-card.scss. Both figures are
	 * already in the markup, so nothing is measured, fetched, or rewritten.
	 *
	 * Scoping to the Section rather than the document means two pricing bands on
	 * one page keep their own state.
	 */
	document.querySelectorAll('[data-price-toggle]').forEach((toggle) => {
		const options = toggle.querySelectorAll('.block-price-toggle__option');
		const scope = toggle.closest('.block-section') || document.body;

		const apply = (period) => {
			toggle.dataset.period = period;
			scope.dataset.pricePeriod = period;
			options.forEach((option) => {
				option.setAttribute('aria-pressed', option.dataset.period === period ? 'true' : 'false');
			});
		};

		// The block renders its default period into the markup; mirror it onto
		// the scope up front so the two never disagree.
		apply(toggle.dataset.period || 'monthly');

		options.forEach((option) => {
			option.addEventListener('click', () => apply(option.dataset.period));
		});
	});
})();
